import { useState } from "react";
import { connect } from "react-redux";
import { setMethodSettingPage } from "../../../../store/action/settingPageAction";
import { METHOD_TYPE } from "../../../../store/reducers/settingPapgeReducer";

const OrderMethod = (props) => {
   const { settingPage, setMethodSettingPage } = props;
   const { type } = settingPage;
   const [isShow, setIsShow] = useState(false);

   return (
      <div className="card card-secondary">
         <p className="card-title mb16">
            Phương thức chốt đơn
         </p>
         <div className="setting-option-wrapper">
            <div className="icon-box">
               {type === METHOD_TYPE.AUTO ?
                  <div className="svg-next-icon setting-campaign-auto">
                  </div>
                  :
                  <div className="svg-next-icon setting-campaign-manual">
                  </div>
               }
            </div>
            <div className="content-box flex-display-row align-items-center justify-content-space-between">
               {type === METHOD_TYPE.AUTO ?
                  <div className="mr36">
                     <p className="card-title mb8">
                        Chốt đơn tự động
                     </p>
                     <span
                        className="card-subtitle">
                        Người mua tự xác nhận đơn hàng trên đơn nháp và thanh toán
                     </span>
                  </div>
                  :
                  <div className="mr36">
                     <p className="card-title mb8">
                        Chốt đơn thủ công
                     </p>
                     <span
                        className="card-subtitle">
                        Hệ thống hỗ trợ nhân viên chốt đơn và xác nhận đơn hàng
                     </span>
                  </div>
               }
               <div className="order-method options-box">
                  <div className="options-box">
                     <span className="" onClick={() => setIsShow(!isShow)}>
                        Thay đổi phương thức
                     </span>
                     <div className="svg-next-icon ic-arrow-down">
                     </div>
                  </div>
                  {isShow &&
                     <div className="app-popover app-popover-hidden-arrow order-method-options">
                        <div className="app-popover-content">
                           <div className="app-popover-arrow"></div>
                           <div className="app-popover-inner" role="tooltip">
                              <div>
                                 <div className="app-popover-inner-content">
                                    <div className="live-stream-popover-option">
                                       <div className="header-box">
                                          <p className="header-text">
                                             Thay đổi phương thức
                                          </p>
                                       </div>
                                       <div className="option-item flex-display-row align-items-center" onClick={() => {
                                          setMethodSettingPage(METHOD_TYPE.MANUAL);
                                          setIsShow(false);
                                       }}>
                                          <div className="mr8">
                                             <div className="svg-next-icon setting-campaign-manual-2" >
                                             </div>
                                          </div>
                                          <div className="desc-box">
                                             <p className="title">
                                                Chốt đơn thủ công
                                             </p>
                                             <span className="subtitle">
                                                Hệ thống hỗ trợ nhân viên chốt đơn<br />và xác nhận đơn hàng
                                             </span>
                                          </div>
                                          {type === METHOD_TYPE.MANUAL &&
                                             <div>
                                                <div className="svg-next-icon ic-check-tick">
                                                </div>
                                             </div>
                                          }
                                       </div>
                                       <div className="option-item flex-display-row align-items-center" onClick={() => {
                                          setMethodSettingPage(METHOD_TYPE.AUTO);
                                          setIsShow(false);
                                       }}>
                                          <div className="mr8">
                                             <div className="svg-next-icon setting-campaign-auto-2">
                                             </div>
                                          </div>
                                          <div className="desc-box">
                                             <p className="title">
                                                Chốt đơn tự động
                                             </p>
                                             <span className="subtitle">
                                                Người mua tự xác nhận đơn hàng trên đơn nháp và thanh toán
                                             </span>
                                          </div>
                                          {type === METHOD_TYPE.AUTO &&
                                             <div>
                                                <div className="svg-next-icon ic-check-tick">
                                                </div>
                                             </div>
                                          }
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  }
               </div>
            </div>
         </div>
      </div>
   )
}

const mapStateToProps = (state) => {
   const { settingPage } = state;

   return {
      settingPage
   };
};

export default connect(mapStateToProps, {
   setMethodSettingPage
})(OrderMethod)
